import { memo } from "react";
import { DialogContent } from "@mui/material";

import AccountRecoveryForm from "components/auth/account-recovery";
import ClosableDialog from "components/shared/ClosableDialog";
import useDialog from "hooks/useDialog";

const AccountRecoveryDialog: React.FC = () => {
  const { openAccountRecoveryDialog, setOpenAccountRecoveryDialog } =
    useDialog();

  return (
    <ClosableDialog
      open={openAccountRecoveryDialog}
      onClose={() => setOpenAccountRecoveryDialog(false)}
    >
      <DialogContent>
        <AccountRecoveryForm />
      </DialogContent>
    </ClosableDialog>
  );
};

export default memo(AccountRecoveryDialog);
